import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ReferenceParams } from 'src/app/models';
import { ApiOrganizationsService, ApiService, LanguageService, NotificationService } from 'src/app/services';

@Component({
  selector: 'app-orgs-integration',
  templateUrl: './orgs-integration.component.html',
  styleUrls: ['./orgs-integration.component.css']
})
export class OrgsIntegrationComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  errorMessages: any;
  language: string;
  loading: boolean;
  orgs: any[] = [];
  codes: any[] = [];
  count:number = 0;

  form: UntypedFormGroup = this.fb.group({
    org_id: ['', Validators.required]
  })

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiOrganizations: ApiOrganizationsService,
    private notification: NotificationService,
    private api: ApiService
    // private validator: ProductAttributesEditValidator
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    // this.errorMessages = this.validator.errorMessages;

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

    this.getOrgs();
  }


  /**
   * 
   */
  getOrgs(): void {

    let params: ReferenceParams = {
      ref_name: 'organizations_for_integration',

      filter: {
        type: ['INPUT', 'TEXTAREA']
      }
    }

    this.subscriptions.add(
      this.apiOrganizations.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("RESPONSE: ", response);


        if (response != null) {

          this.orgs = response.result;

        }
      })
    );

  }

  /**
   * 
   */
  getBarcodes() {


    let obj = {
      initiator_org_id: this.form.get('org_id').value
    }

    this.api.post('getSameBarcodes', obj, 'private', 'files').subscribe((response: any) => {
      console.log("RESPONSE: ", response);

      if (response != null) {

        this.codes = response.result.barcodes;

        this.count = response.result.count;

        this.codes.forEach((val, index)=>{

          if(val == ''){

            this.codes.splice(index, 1);
          }
        })


      }
    })

  }

  onCreate(){

    let obj = {
      initiator_org_id: this.form.get('org_id').value
    }

    this.api.post('integrationBetweenOrganizations', obj, 'private', 'files').subscribe((response: any) => {
      console.log("RESPONSE: ", response);


      if (response != null) {

        this.notification.show('success', 'Данные успешно сохранены!');
      }
    })

  }

}
